import React from 'react';
import { useDispatch } from 'react-redux';
import type { SchemaBundle } from '../../api/artifacts/interface';
import { useSelector } from '../store';
import { actions as schemasActions } from './logic';

interface SchemaHookState {
  bundle: SchemaBundle | undefined;
  hasSchema: boolean;
  status: string;
}

interface SchemaHookHandler {
  fetchSchema: () => void;
}

export default function useSchemaHook(
  schemaName: string
): [SchemaHookState, SchemaHookHandler] {
  const dispatch = useDispatch();
  const bundle = useSelector((s) => s.schemas.byName[schemaName]);
  const hasSchema = useSelector(
    (s) => s.schemas.byName[schemaName] !== undefined
  );
  const status = useSelector(
    (s) => s.schemas.statusByName[schemaName] ?? 'uninitialized'
  );

  const handler = React.useMemo<SchemaHookHandler>(
    () => ({
      fetchSchema: () => {
        dispatch(schemasActions.fetchSchema(schemaName));
      },
    }),
    [dispatch, schemaName]
  );

  return [{ bundle, hasSchema, status }, handler];
}
